var getPropsToForward = function getPropsToForward(_ref) {
  var props = _ref.props,
      _ref$prefixesToForwar = _ref.prefixesToForward,
      prefixesToForward = _ref$prefixesToForwar === void 0 ? ['data-'] : _ref$prefixesToForwar;
  var propsToForward = {};
  Object.keys(props).forEach(function (propName) {
    prefixesToForward.forEach(function (prefaceName) {
      if (propName.slice(0, prefaceName.length) === prefaceName) {
        propsToForward[propName] = props[propName];
      }
    });
  });
  return propsToForward;
};

export { getPropsToForward };
